import React from "react";
import UnsubscribeProfileContainer from "../containers/UnsubscribeProfileContainer";

export const UnsubscribeProfilePage: React.FunctionComponent = () => <UnsubscribeProfileContainer />;